import { Contacts, ContactsApi, Salutation } from '../../../@types/types'
import { getSalutation } from '../../../services/conversion/conversionServices'

export const contactsToApp = (contacts: ContactsApi | undefined): Contacts =>
  contacts
    ? contacts.map((item) => {
        return {
          contactId: item.contactId,
          salutationType: item.salutationType ? getSalutation(item.salutationType) : Salutation.NO_SALUTATION,
          lastName: item.lastName,
          firstName: item.firstName,
          phoneNumber: item.phoneNumber,
          email: item.email,
          faxNumber: item.faxNumber,
          cellPhoneNumber: item.cellPhoneNumber,
          title: item.title,
          defaultContact: item.defaultContact,
          address: {
            street: item.address.street,
            number: item.address.number,
            postcode: item.address.postcode,
            city: item.address.city,
          },
        }
      })
    : []
